var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownListEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26304_31802)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26304_31802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8114 16.6873C29.4262 16.3019 28.8139 16.2776 28.3998 16.615C28.3399 16.6638 28.3863 16.6208 27.4746 17.5325L29.8412 19.8992L30.6917 19.0592C31.1029 18.648 31.1029 17.9789 30.6917 17.5677L29.8114 16.6873Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6213 22.4315L21.2292 25.4146C21.1354 25.6156 21.1773 25.8537 21.3341 26.0105C21.4909 26.1674 21.7292 26.2093 21.93 26.1155L24.9132 24.7234C25.0312 24.6683 24.6739 25.0027 29.0905 20.6412L26.7286 18.2793C22.3496 22.6583 22.6775 22.3112 22.6213 22.4315Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8022 25.3709C25.673 25.4984 25.5242 25.6019 25.3598 25.6786L22.3766 27.0708C21.79 27.3446 21.0733 27.2403 20.589 26.7559C20.1203 26.2872 19.9937 25.5688 20.274 24.9681L21.6661 21.9849C21.7443 21.8174 21.8503 21.6662 21.981 21.5354L26.4658 17.0506V12.582C26.4658 11.7097 25.7561 11 24.8838 11H14.583C13.7107 11 13.001 11.7097 13.001 12.582V27.418C13.001 28.2903 13.7107 29 14.583 29H24.8838C25.7561 29 26.4658 28.2903 26.4658 27.418V24.7155L25.8022 25.3709ZM15.8135 14.4102H23.6885C23.9797 14.4102 24.2159 14.6463 24.2159 14.9375C24.2159 15.2287 23.9797 15.4648 23.6885 15.4648H15.8135C15.5223 15.4648 15.2862 15.2287 15.2862 14.9375C15.2862 14.6463 15.5223 14.4102 15.8135 14.4102ZM15.8135 17.2227H22.001C22.2922 17.2227 22.5284 17.4588 22.5284 17.75C22.5284 18.0412 22.2922 18.2773 22.001 18.2773H15.8135C15.5223 18.2773 15.2862 18.0412 15.2862 17.75C15.2862 17.4588 15.5223 17.2227 15.8135 17.2227ZM15.2862 20.5625C15.2862 20.2713 15.5223 20.0352 15.8135 20.0352H20.3135C20.6047 20.0352 20.8409 20.2713 20.8409 20.5625C20.8409 20.8537 20.6047 21.0898 20.3135 21.0898H15.8135C15.5223 21.0898 15.2862 20.8537 15.2862 20.5625Z",
    fill: "#4251DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26304_31802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26304_31802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownListEdit);
export default __webpack_public_path__ + "static/media/dropdown-list-edit.ac7ce004e504cc811c161837d6cf633f.svg";
export { ForwardRef as ReactComponent };